// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading__container {
	width: 100%;
	padding: 80px 24px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: #ffffff;
	border-radius: 10px;
	gap: 36px;
}

.loading-container__full-page {
	width: 100%;
	height: 100vh;
	background-color: #ffffff;
	border-radius: 0;
}

.loading__text {
	font-size: 16px;
	line-height: 20px;
	color: #191919;
	font-weight: 500;
}

.loader__animation {
	width: 48px;
	height: 48px;
	margin: auto;
	position: relative;
}

.loader__animation:before {
	content: "";
	width: 48px;
	height: 5px;
	background: #4db8ff50;
	position: absolute;
	top: 60px;
	left: 0;
	border-radius: 50%;
	animation: shadow324 0.5s linear infinite;
}

.loader__animation:after {
	content: "";
	width: 100%;
	height: 100%;
	background: #4db8ff;
	position: absolute;
	top: 0;
	left: 0;
	border-radius: 4px;
	animation: jump7456 0.5s linear infinite;
}

@keyframes jump7456 {
	15% {
		border-bottom-right-radius: 3px;
	}

	25% {
		transform: translateY(9px) rotate(22.5deg);
	}

	50% {
		transform: translateY(18px) scale(1, 0.9) rotate(45deg);
		border-bottom-right-radius: 40px;
	}

	75% {
		transform: translateY(9px) rotate(67.5deg);
	}

	100% {
		transform: translateY(0) rotate(90deg);
	}
}

@keyframes shadow324 {
	0%,
	100% {
		transform: scale(1, 1);
	}

	50% {
		transform: scale(1.2, 1);
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/components/common/Loading/Loading.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,yBAAyB;CACzB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,aAAa;CACb,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,WAAW;CACX,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,kBAAkB;CAClB,yCAAyC;AAC1C;;AAEA;CACC,WAAW;CACX,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,kBAAkB;CAClB,wCAAwC;AACzC;;AAEA;CACC;EACC,+BAA+B;CAChC;;CAEA;EACC,0CAA0C;CAC3C;;CAEA;EACC,uDAAuD;EACvD,gCAAgC;CACjC;;CAEA;EACC,0CAA0C;CAC3C;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA;CACC;;EAEC,sBAAsB;CACvB;;CAEA;EACC,wBAAwB;CACzB;AACD","sourcesContent":[".loading__container {\n\twidth: 100%;\n\tpadding: 80px 24px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: #ffffff;\n\tborder-radius: 10px;\n\tgap: 36px;\n}\n\n.loading-container__full-page {\n\twidth: 100%;\n\theight: 100vh;\n\tbackground-color: #ffffff;\n\tborder-radius: 0;\n}\n\n.loading__text {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #191919;\n\tfont-weight: 500;\n}\n\n.loader__animation {\n\twidth: 48px;\n\theight: 48px;\n\tmargin: auto;\n\tposition: relative;\n}\n\n.loader__animation:before {\n\tcontent: \"\";\n\twidth: 48px;\n\theight: 5px;\n\tbackground: #4db8ff50;\n\tposition: absolute;\n\ttop: 60px;\n\tleft: 0;\n\tborder-radius: 50%;\n\tanimation: shadow324 0.5s linear infinite;\n}\n\n.loader__animation:after {\n\tcontent: \"\";\n\twidth: 100%;\n\theight: 100%;\n\tbackground: #4db8ff;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tborder-radius: 4px;\n\tanimation: jump7456 0.5s linear infinite;\n}\n\n@keyframes jump7456 {\n\t15% {\n\t\tborder-bottom-right-radius: 3px;\n\t}\n\n\t25% {\n\t\ttransform: translateY(9px) rotate(22.5deg);\n\t}\n\n\t50% {\n\t\ttransform: translateY(18px) scale(1, 0.9) rotate(45deg);\n\t\tborder-bottom-right-radius: 40px;\n\t}\n\n\t75% {\n\t\ttransform: translateY(9px) rotate(67.5deg);\n\t}\n\n\t100% {\n\t\ttransform: translateY(0) rotate(90deg);\n\t}\n}\n\n@keyframes shadow324 {\n\t0%,\n\t100% {\n\t\ttransform: scale(1, 1);\n\t}\n\n\t50% {\n\t\ttransform: scale(1.2, 1);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
